// components/search/more/SearchSuggestionsEmpty.tsx
import { Search } from "lucide-react";
import EmptyState from "@/app/components/elements/EmptyState";

interface SearchSuggestionsEmptyProps {
  query: string;
}

const SearchSuggestionsEmpty = ({ query }: SearchSuggestionsEmptyProps) => (
  <EmptyState
    icon={Search}
    title="Sonuç bulunamadı"
    description={`"${query}" için herhangi bir öneri bulunamadı`}
    className="py-8 min-h-0"
  />
);

export default SearchSuggestionsEmpty;
